import {Form, Input, Select} from "antd";

import "./Filters.css"
import {FilterSelectSelectOption} from "./FilterSelect";

export interface FilterBooleanSelectOption {
    value: string | number;
    label: string;
}
export interface FilterBooleanProps{
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    defaultValue?:boolean
}

export function FilterBoolean(props:FilterBooleanProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    function onChange(value:any){
        if(props?.onChange){
            props?.onChange(value.target.value)
        }
    }

    const className = "filter " + (props?.className ?? "");

    const options: FilterSelectSelectOption[] = [
        { value: 'true', label: 'Vero' },
        { value: 'false', label: 'Falso' }
    ];

    const stringDefaultValue = props.defaultValue !== undefined ? String(props.defaultValue) : undefined;

    return <>
        <Form.Item name={props.dataKey}
                   label={props.label}
                   rules={rules}
                   initialValue={stringDefaultValue}
        >
            <Select className={className}
                    placeholder={props.placeholder}
                    onChange={onChange}
                    allowClear={true}
                    options={options}
                    style={{width: 150}}
            >
            </Select>
        </Form.Item>
    </>

}